const prefixCls = 'web.login.';
export const localesLogin = {
  [prefixCls + 'welcome']: {
    zh_CN: '欢迎使用极速卖家',
    en_GB: 'Welcome to Speedy Seller',
  },
  [prefixCls + 'tagline']: {
    zh_CN: '极速卖家，火力全开',
    en_GB: 'Speedy Seller, Full Throttle',
  },
  [prefixCls + 'desc']: {
    zh_CN:
      'Semi-admin 基于 React17、Semi-UI、TypeScript，为开发中大型项目提供开箱即用的解决方案.',
    en_GB:
      'Semi-admin is based on React17, Semi-UI, TypeScript,  provides out-of-the-box solutions for developing medium and large projects',
  },
  [prefixCls + 'userName']: {
    zh_CN: '用户名',
    en_GB: 'Account',
  },
  [prefixCls + 'password']: {
    zh_CN: '密码',
    en_GB: 'Password',
  },
  [prefixCls + 'remember']: {
    zh_CN: '记住账号',
    en_GB: 'remember me',
  },
  [prefixCls + 'forgetPassword']: {
    zh_CN: '忘记密码?',
    en_GB: 'forget Password?',
  },
  [prefixCls + 'loginText']: {
    zh_CN: '现在登录',
    en_GB: 'Login now',
  },
  [prefixCls + 'register']: {
    zh_CN: '注册账号',
    en_GB: 'Create Account',
  },
  [prefixCls + 'join']: {
    zh_CN: '或者选择其他方式登录',
    en_GB: 'Or you can join with',
  },
  [prefixCls + 'errorUserNameNull']: {
    zh_CN: '请输入用户名',
    en_GB: 'Please enter username',
  },
  [prefixCls + 'errorPasswordNull']: {
    zh_CN: '请输入密码',
    en_GB: 'Please enter password',
  },
  [prefixCls + 'getUserInfoFailed']: {
    zh_CN: '获取用户信息失败',
    en_GB: 'Failed to get user information',
  },
  [prefixCls + 'systemTitle']: {
    zh_CN: '后台管理系统登录',
    en_GB: 'Admin System Login',
  },
};
